module.exports = "<h3 class=\"text-center mt-5\">Please wait while Redirect to the website</h3>"